<template>
    <div>
        <h5 class="is-size-5 store-navigation-color">{{location.name}}</h5>
        <div class="level">
            <div class="level-left">
                <div class="level-item">
                    <p>{{location.address}}</p>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                    <a id="change-store-txt" @click="$emit('change-location')" class="store-loyalty-color">Change Store</a>
                </div>
            </div>
        </div>
            
        <BaseMap v-if="location.id" :location="location"/>
    </div>
</template>


<script>
import { LOCATION } from '@/stores/defs';

export default {
    props: {
        location: {
            type: Object,
            default: {}
        }
    }
};
</script>

<style lang="scss">
    @import 'globalStyles';

    @include desktop {
        #change-store-txt {
            padding-left: 1em;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/store-locator/LocationDetail.vue